import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FaSave } from 'react-icons/fa';
import Button from 'react-bootstrap/Button';
import LoadingComponent from '../../widgets/LoadingComponent';
import { getData } from '../../api/ApiRest'
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import { updateEmpresaNominaSoftware } from './EmpresaApi'
import { formatDateddMMyyyyhhmm } from '../../widgets/DateTime'




function EmpresaSoftwareCrud({ Show, cerrarModal, CompanySelect }) {
    const [loading, setLoading] = useState(false);
    const [nominaSoftwareData, setNominaSoftwareData] = useState({ id: '', pin: '', created: '', lastUpdated: '' })

    const initForm = () => {
        setNominaSoftwareData({ id: '', pin: '', created: '', lastUpdated: '' });
        setLoading(true);

        getData('api/Configuracion/Company/SoftwareGetData', { Companyid: CompanySelect.id, Type: 'Nm' },
            false).then(response => {

                if (response.status === true) {
                    setNominaSoftwareData(response.software);
                }

                setLoading(false);

            }, error => {
                console.log(error);
                setLoading(false);
                alert('Algo salio mal al cargar el formulario');
            })
    }


    const guardarNominaSoftware = (event) => {
        event.preventDefault();
        if (CompanySelect.nomina_Ambienteid === 1) {
            alert('Ya estas en produccion de facturacion electronica y no se puede cambiar el software');
            return;
        }

        setLoading(true);
       

        updateEmpresaNominaSoftware(nominaSoftwareData.id, nominaSoftwareData.pin,
            CompanySelect.user_Api_Token).then(response => {
                alert(response.message);
                if (response.success === true) {
                    cerrarModal(true);
                }

            }, error => {
                console.log(error, 'error');
            })
    }


    const fechaAct = () => {
        if (nominaSoftwareData.id !== '') {

            return <div className='row mt-5'>
                <div className='col-md-4'>
                    <label>Creacion</label>
                    <input className='form-control form-control-sm'
                        value={formatDateddMMyyyyhhmm(nominaSoftwareData.created)} readOnly />
                </div>

                <div className='col-md-4'>
                    <label>Ultima actualización</label>
                    <input className='form-control form-control-sm'
                        value={formatDateddMMyyyyhhmm(nominaSoftwareData.lastUpdated)} readOnly />
                </div>

            </div>

        }
    }


    return <Modal
        size='xl'
        show={Show}
        onShow={initForm}
        onHide={cerrarModal}>
        <Modal.Header closeButton>
            <Modal.Title>SOFTWARE NOMINA DE {CompanySelect.empresa_Nombre}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {<LoadingComponent Loading={loading} />}

            <form onSubmit={guardarNominaSoftware}>
                <div className='row'>
                    <div className='col-md-8'>
                        <FloatingLabel
                            controlId="Id"
                            label="Id"
                        >
                            <Form.Control
                                type="text"
                                required={true}
                                autoComplete='off'
                                placeholder="Id"
                                value={nominaSoftwareData.id}
                                onChange={value => setNominaSoftwareData({ ...nominaSoftwareData, id: value.target.value })}
                            />
                        </FloatingLabel>
                    </div>

                    <div className='col-md-3'>
                        <FloatingLabel
                            controlId="Pin"
                            label="Pin"
                        >
                            <Form.Control
                                type="text"
                                required={true}
                                autoComplete='off'
                                placeholder="Pin"
                                value={nominaSoftwareData.pin}
                                onChange={value => setNominaSoftwareData({ ...nominaSoftwareData, pin: value.target.value })}
                            />
                        </FloatingLabel>
                    </div>

                    <div className='col-md-1'>
                        <Button type='submit' variant='success' title='Guardar'>
                            <FaSave size={'1.5rem'} />
                        </Button>
                    </div>

                </div>

            </form>



            {fechaAct()}

        </Modal.Body>
    </Modal >

}

export default EmpresaSoftwareCrud;